export const assetUrl = (path: string): string => {
  return `https://assets.freightview.com/${path}`
}
